import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ReduxRouter } from '@lagunovsky/redux-react-router';
import './polyfills';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';
import buildFontAwesomeLibrary from './buildFontAwesomeLibrary';
import history from './lib/history';
import { store } from './store';

buildFontAwesomeLibrary();

const rootElement = document.getElementById('root') as HTMLElement;

if (!rootElement) {
	throw new Error('Failed to find the root element');
}

const root = createRoot(rootElement);

root.render(
	<Provider store={store}>
		<ReduxRouter history={history}>
			<App />
		</ReduxRouter>
	</Provider>,
);

